<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let expanded: boolean = false;

</script>

<span class="fizz-hide-on-large">
  {#if expanded}
    <Icon width="12" height="12" type="ArrowUp" />
  {:else}
    <Icon width="12" height="12" type="ArrowDown" />
  {/if}
</span>
